function sliderProducts(){
  $('.type-category.haveCustomProduct #products:not(.customProductLine)').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  centerMode: false,
  autoplay: false,
  dots: false,
  arrows: true,
  infinite: true,
  adaptiveHeight: false,
  responsive: [
    {
      breakpoint: 1199,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: true,
      }
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        dots: true,
      }
      
    },
    {
      breakpoint: 350,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        dots: true,
        arrows:false
      }
      
    }
    ,
    {
      breakpoint: 330,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows:false
      }
      
    }
      
    
  ]
  });
}

if($('.type-detail').length){
  $('.products-additional').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    centerMode: false,
    autoplay: false,
    dots: false,
    arrows: true,
    infinite: true,
    adaptiveHeight: false,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          dots: true,
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          dots: true,
        }
        
      },
      {
        breakpoint: 350,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          dots: true,
          arrows:false
        }
        
      }
      ,
      {
        breakpoint: 330,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows:false
        }
        
      }
        
      
    ]
    });
}